import currencyJS, { Options } from 'currency.js';

import { Currency } from '@/core/currency/interfaces';
import { CURRENCIES } from '@/core/currency/constants';

/**
 * @param code - Numeric currency code either as string or number
 * @returns Currency Data
 */
export const getCurrencyInfo = (code: number | string): Currency | undefined => CURRENCIES[code];

/**
 * @param code - Numeric currency code either as string or number
 * @param amount - In cents
 * @param options - currency.js options, fromCents defaults to true
 * @param formatOptions - currency.js formatting options
 * @returns Formatted amount
 */
export const formatAmount = (code: number | string, amount: number, options?: Options, formatOptions?: Options) => {
    const currency = getCurrencyInfo(code);

    if (!currency) {
        return '';
    }

    const { thousands, decimal } = currency.delimiters;

    return currencyJS(amount, {
        fromCents: true,
        ...options
    }).format({
        symbol: currency.symbol,
        separator: thousands,
        decimal,
        ...formatOptions
    });
};
